import React, {Component} from 'react';
import {connect} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import SOQModal from '../stock/soqModal';
import OnOrderModal from '../stock/onOrderModal';
import BackOrderModal from '../stock/backOrderModal';
import PartCheckModal from '../stock/partCheckModal';
import PartInfo from '../stock/partInfo';
import Header from './headSection';
import Detail from './detail';
import './manualOrders.scss';

class ProviderManualOrders extends Component {
  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.ProviderManualOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    const date = new Date();
    this.props.restoreProviderManualOrder();
    this.props.getProviderOrderLimit({'year': date.getFullYear()});
  }

  render() {
    return (
      <div className='provider-manual-orders'>
        <SOQModal />
        <BackOrderModal />
        <OnOrderModal />
        <PartCheckModal />
        <Header />
        <Detail />
        <PartInfo />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};

const {
  withRouter,
  getProviderOrderLimit,
  restoreProviderManualOrder,
  navigateTo,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  getProviderOrderLimit,
  restoreProviderManualOrder,
  navigateTo,
})(ProviderManualOrders));
